<div class="flex flex-column gap-4" [formGroup]="form">

    <p-accordion [multiple]="true" [activeIndex]="[0,1,2,3,4,5,6,7,8]" expandIcon="pi pi-chevron-down"
        collapseIcon="pi pi-chevron-up">
        <p-accordionTab header="Application Information">
            <div class="formgrid grid">
                <div class="field col-12 md:col-4">
                    <label class="font-medium text-900">Application Fees</label>
                    <input pInputText type="text" class="w-full" placeholder="$ e.g. 75"
                        formControlName="applicationFees" />
                    <div *ngIf="form.get('applicationFees')?.touched && form.get('applicationFees')?.invalid">
                        <small *ngIf="form.get('applicationFees')?.hasError('required')"
                            class="p-error block mt-1">Application Fees is required.</small>
                        <small *ngIf="form.get('applicationFees')?.hasError('pattern')" class="p-error block mt-1">Must
                            be a number.</small>
                    </div>
                </div>
                <div class="field col-12 md:col-4">
                    <label class="font-medium text-900">Currency</label>
                    <p-dropdown [options]="currency" optionLabel="label" optionValue="value"
                        placeholder="Select Currency" styleClass="w-full" [showClear]="true"
                        formControlName="currency"></p-dropdown>
                    <small *ngIf="form.get('currency')?.invalid && form.get('currency')?.touched"
                        class="p-error block mt-1">
                        Currency is required.
                    </small>
                </div>
                <div class="field col-12 md:col-4">
                    <label class="font-medium text-900">Total Applicants</label>
                    <input pInputText type="number" class="w-full" placeholder="Number of applicants"
                        formControlName="totalApplicants" />
                    <div *ngIf="form.get('totalApplicants')?.touched && form.get('totalApplicants')?.invalid">
                        <small *ngIf="form.get('totalApplicants')?.hasError('pattern')" class="p-error block mt-1">Must
                            be a number.</small>
                    </div>
                </div>
                <div class="field col-12 md:col-6">
                    <label class="font-medium text-900">Early Action Deadline</label>
                    <p-calendar formControlName="earlyActionDeadline" [showIcon]="true" dateFormat="mm/dd/yy"
                        placeholder="MM/DD/YYYY" styleClass="w-full">
                    </p-calendar>
                </div>
                <div class="field col-12 md:col-6">
                    <label class="font-medium text-900">Early Decision 1 Deadline</label>
                    <p-calendar formControlName="earlyDecision1Deadline" [showIcon]="true" dateFormat="mm/dd/yy"
                        placeholder="MM/DD/YYYY" styleClass="w-full"></p-calendar>
                </div>
                <div class="field col-12 md:col-6">
                    <label class="font-medium text-900">Early Decision II Deadline</label>
                    <p-calendar formControlName="earlyDecision2Deadline" [showIcon]="true" dateFormat="mm/dd/yy"
                        placeholder="MM/DD/YYYY" styleClass="w-full"></p-calendar>
                </div>
                <div class="field col-12 md:col-6">
                    <label class="font-medium text-900">Regular Decision Deadline</label>
                    <p-calendar formControlName="regularDecisionDeadline" [showIcon]="true" dateFormat="mm/dd/yy"
                        placeholder="MM/DD/YYYY" styleClass="w-full"></p-calendar>
                </div>
                <div class="field col-12 md:col-6">
                    <label class="font-medium text-900">Medical Applications Deadline</label>
                    <p-calendar formControlName="medicalApplicationsDeadline" [showIcon]="true" dateFormat="mm/dd/yy"
                        placeholder="MM/DD/YYYY" styleClass="w-full"></p-calendar>
                </div>
            </div>
        </p-accordionTab>

        <p-accordionTab header="Test Scores & Requirements">
            <div class="formgrid grid">
                <div class="field col-12 md:col-4">
                    <label class="font-medium text-900">90th Percentile SAT Reading & Writing</label>
                    <input pInputText type="text" class="w-full" placeholder="0-800"
                        formControlName="satReadingWriting90" />
                    <div *ngIf="form.get('satReadingWriting90')?.touched && form.get('satReadingWriting90')?.invalid">
                        <small *ngIf="form.get('satReadingWriting90')?.hasError('pattern')"
                            class="p-error block mt-1">Must be a number.</small>
                    </div>
                </div>
                <div class="field col-12 md:col-4">
                    <label class="font-medium text-900">90th Percentile SAT Math</label>
                    <input pInputText type="text" class="w-full" placeholder="0-800" formControlName="satMath90" />
                    <div *ngIf="form.get('satMath90')?.touched && form.get('satMath90')?.invalid">
                        <small *ngIf="form.get('satMath90')?.hasError('pattern')" class="p-error block mt-1">Must be a
                            number.</small>
                    </div>
                </div>
                <div class="field col-12 md:col-4">
                    <label class="font-medium text-900">Midpoint Overall SAT</label>
                    <input pInputText type="text" class="w-full" placeholder="400-1600"
                        formControlName="satOverallMidpoint" />
                    <div *ngIf="form.get('satOverallMidpoint')?.touched && form.get('satOverallMidpoint')?.invalid">
                        <small *ngIf="form.get('satOverallMidpoint')?.hasError('pattern')"
                            class="p-error block mt-1">Must be a number.</small>
                    </div>
                </div>
                <div class="field col-12 md:col-4">
                    <label class="font-medium text-900">90th Percentile ACT Composite</label>
                    <input pInputText type="text" class="w-full" placeholder="1-36" formControlName="actComposite90" />
                    <div *ngIf="form.get('actComposite90')?.touched && form.get('actComposite90')?.invalid">
                        <small *ngIf="form.get('actComposite90')?.hasError('pattern')" class="p-error block mt-1">Must
                            be a number.</small>
                    </div>
                </div>
                <div class="field col-12 md:col-4">
                    <label class="font-medium text-900">90th Percentile ACT English</label>
                    <input pInputText type="text" class="w-full" placeholder="1-36" formControlName="actEnglish90" />
                    <div *ngIf="form.get('actEnglish90')?.touched && form.get('actEnglish90')?.invalid">
                        <small *ngIf="form.get('actEnglish90')?.hasError('pattern')" class="p-error block mt-1">Must be
                            a number.</small>
                    </div>
                </div>
                <div class="field col-12 md:col-4">
                    <label class="font-medium text-900">Midpoint ACT Math</label>
                    <input pInputText type="text" class="w-full" placeholder="1-36" formControlName="actMathMidpoint" />
                    <div *ngIf="form.get('actMathMidpoint')?.touched && form.get('actMathMidpoint')?.invalid">
                        <small *ngIf="form.get('actMathMidpoint')?.hasError('pattern')" class="p-error block mt-1">Must
                            be a number.</small>
                    </div>
                </div>
                <div class="field col-12 md:col-4">
                    <label class="font-medium text-900">% Students Submitting SAT </label>
                    <input pInputText type="text" class="w-full" placeholder="0-100"
                        formControlName="percentSATSubmitting" />
                    <div *ngIf="form.get('percentSATSubmitting')?.touched && form.get('percentSATSubmitting')?.invalid">
                        <small *ngIf="form.get('percentSATSubmitting')?.hasError('pattern')"
                            class="p-error block mt-1">Must be a number.</small>
                    </div>
                </div>
                <div class="field col-12 md:col-4">
                    <label class="font-medium text-900">% Students Submitting ACT</label>
                    <input pInputText type="text" class="w-full" placeholder="0-100"
                        formControlName="percentACTSubmitting" />
                    <div *ngIf="form.get('percentACTSubmitting')?.touched && form.get('percentACTSubmitting')?.invalid">
    
                        <small *ngIf="form.get('percentACTSubmitting')?.hasError('pattern')"
                            class="p-error block mt-1">Must be a number.</small>
                    </div>
                </div>
            </div>
        </p-accordionTab>

        <p-accordionTab header="Admission Requirements">
            <div class="formgrid grid">
                <div class="field col-12 md:col-6">
                    <label class="font-medium text-900">Secondary School GPA Requirement</label>
                    <input pInputText type="text" class="w-full" placeholder="e.g., Required, Recommended"
                        formControlName="secondarySchoolGPAMode" />
                    <div
                        *ngIf="form.get('secondarySchoolGPAMode')?.touched && form.get('secondarySchoolGPAMode')?.invalid">
                        <small *ngIf="form.get('secondarySchoolGPAMode')?.hasError('pattern')"
                            class="p-error block mt-1">Must be alphabetic.</small>
                    </div>
                </div>
                <div class="field col-12 md:col-6">
                    <label class="font-medium text-900">Secondary School Rank Requirement</label>
                    <input pInputText type="text" class="w-full" placeholder="e.g., Required, Recommended"
                        formControlName="secondarySchoolRankMode" />
                    <div
                        *ngIf="form.get('secondarySchoolRankMode')?.touched && form.get('secondarySchoolRankMode')?.invalid">
                        <small *ngIf="form.get('secondarySchoolRankMode')?.hasError('pattern')"
                            class="p-error block mt-1">Must be alphabetic.</small>
                    </div>
                </div>
                <div class="field col-12 md:col-6">
                    <label class="font-medium text-900">Secondary School Record Requirement</label>
                    <input pInputText type="text" class="w-full" placeholder="e.g., Required"
                        formControlName="secondarySchoolRecordMode" />
                    <div
                        *ngIf="form.get('secondarySchoolRecordMode')?.touched && form.get('secondarySchoolRecordMode')?.invalid">
                        <small *ngIf="form.get('secondarySchoolRecordMode')?.hasError('pattern')"
                            class="p-error block mt-1">Must be alphabetic.</small>
                    </div>
                </div>
                <div class="field col-12 md:col-6">
                    <label class="font-medium text-900">College Prep Program Requirement</label>
                    <input pInputText type="text" class="w-full" placeholder="e.g., Recommended"
                        formControlName="collegePrepProgramMode" />
                    <div
                        *ngIf="form.get('collegePrepProgramMode')?.touched && form.get('collegePrepProgramMode')?.invalid">
                        <small *ngIf="form.get('collegePrepProgramMode')?.hasError('pattern')"
                            class="p-error block mt-1">Must be alphabetic.</small>
                    </div>
                </div>
                <div class="field col-12 md:col-6">
                    <label class="font-medium text-900">Recommendations</label>
                    <input pInputText type="text" class="w-full" placeholder="e.g., 2 letters required"
                        formControlName="recommendations" />
                    <div *ngIf="form.get('recommendations')?.touched && form.get('recommendations')?.invalid">
                        <small *ngIf="form.get('recommendations')?.hasError('pattern')" class="p-error block mt-1">Must
                            be alphabetic.</small>
                    </div>
                </div>
                <div class="field col-12 md:col-6">
                    <label class="font-medium text-900">Essay/Personal Statement</label>
                    <input pInputText type="text" class="w-full" placeholder="e.g., Required"
                        formControlName="essayPersonalStatement" />
                    <div
                        *ngIf="form.get('essayPersonalStatement')?.touched && form.get('essayPersonalStatement')?.invalid">
                        <small *ngIf="form.get('essayPersonalStatement')?.hasError('pattern')"
                            class="p-error block mt-1">Must be alphabetic.</small>
                    </div>
                </div>
                <div class="field col-12">
                    <label class="font-medium text-900">Admission Test Score Requirements</label>
                    <textarea pInputTextarea rows="2" class="w-full" placeholder="Detail test score requirements"
                        formControlName="admissionTestScoreRequirements"></textarea>
                    <div
                        *ngIf="form.get('admissionTestScoreRequirements')?.touched && form.get('admissionTestScoreRequirements')?.invalid">
                        <small *ngIf="form.get('admissionTestScoreRequirements')?.hasError('pattern')"
                            class="p-error block mt-1">Must be alphabetic.</small>
                    </div>
                </div>
                <div class="field col-12">
                    <label class="font-medium text-900">English Language Requirement</label>
                    <textarea pInputTextarea rows="2" class="w-full"
                        placeholder="Detail English proficiency requirements (TOEFL, IELTS, etc.)"
                        formControlName="englishLanguageRequirement"></textarea>
                    <div
                        *ngIf="form.get('englishLanguageRequirement')?.touched && form.get('englishLanguageRequirement')?.invalid">
                        <small *ngIf="form.get('englishLanguageRequirement')?.hasError('pattern')"
                            class="p-error block mt-1">Must be alphabetic.</small>
                    </div>
                </div>
                <div class="field col-12 md:col-6">
                    <label class="font-medium text-900">Formal Demonstration of Competencies</label>
                    <input pInputText type="text" class="w-full" placeholder="e.g., Required"
                        formControlName="formalDemonstrationCompetences" />
                    <div
                        *ngIf="form.get('formalDemonstrationCompetences')?.touched && form.get('formalDemonstrationCompetences')?.invalid">
                        <small *ngIf="form.get('formalDemonstrationCompetences')?.hasError('pattern')"
                            class="p-error block mt-1">Must be alphabetic.</small>
                    </div>
                </div>
                <div class="field col-12 md:col-6">
                    <label class="font-medium text-900">Work Experience Required</label>
                    <input pInputText type="text" class="w-full" placeholder="e.g., Required"
                        formControlName="workExperienceRequired" />
                    <div
                        *ngIf="form.get('workExperienceRequired')?.touched && form.get('workExperienceRequired')?.invalid">
                        <small *ngIf="form.get('workExperienceRequired')?.hasError('pattern')"
                            class="p-error block mt-1">Must be alphabetic.</small>
                    </div>
                </div>
                <div class="field col-12 md:col-6">
                    <label class="font-medium text-900">Legacy Status Requirement</label>
                    <input pInputText type="text" class="w-full" placeholder="e.g., Considered"
                        formControlName="legacyStatus" />
                    <div *ngIf="form.get('legacyStatus')?.touched && form.get('legacyStatus')?.invalid">
                        <small *ngIf="form.get('legacyStatus')?.hasError('pattern')" class="p-error block mt-1">Must be
                            alphabetic.</small>
                    </div>
                </div>
            </div>
        </p-accordionTab>

        <p-accordionTab header="Cost & Financial Aid">
            <div class="formgrid grid">
                <div class="field col-12 md:col-4">
                    <label class="font-medium text-900">Average Cost of Attendance</label>
                    <input pInputText type="text" class="w-full" placeholder="$ Total cost"
                        formControlName="avgCostOfAttendance" />
                    <div *ngIf="form.get('avgCostOfAttendance')?.touched && form.get('avgCostOfAttendance')?.invalid">
                        <small *ngIf="form.get('avgCostOfAttendance')?.hasError('pattern')"
                            class="p-error block mt-1">Must be a number.</small>
                    </div>
                </div>
                <div class="field col-12 md:col-4">
                    <label class="font-medium text-900">Average Tuition Fees</label>
                    <input pInputText type="text" class="w-full" placeholder="$ Tuition only"
                        formControlName="avgTuitionFees" />
                    <div *ngIf="form.get('avgTuitionFees')?.touched && form.get('avgTuitionFees')?.invalid">
                        <small *ngIf="form.get('avgTuitionFees')?.hasError('pattern')" class="p-error block mt-1">Must
                            be a number.</small>
                    </div>
                </div>
                <div class="field col-12 md:col-4">
                    <label class="font-medium text-900">Estimated Books & Supplies</label>
                    <input pInputText type="text" class="w-full" placeholder="$ Books cost"
                        formControlName="estimatedBooksSupplies" />
                    <div
                        *ngIf="form.get('estimatedBooksSupplies')?.touched && form.get('estimatedBooksSupplies')?.invalid">
                        <small *ngIf="form.get('estimatedBooksSupplies')?.hasError('pattern')"
                            class="p-error block mt-1">Must be a number.</small>
                    </div>
                </div>
                <div class="field col-12 md:col-4">
                    <label class="font-medium text-900">On-Campus Room & Board</label>
                    <input pInputText type="text" class="w-full" placeholder="$ Room & board"
                        formControlName="onCampusRoomBoard" />
                    <div *ngIf="form.get('onCampusRoomBoard')?.touched && form.get('onCampusRoomBoard')?.invalid">
                        <small *ngIf="form.get('onCampusRoomBoard')?.hasError('pattern')"
                            class="p-error block mt-1">Must be a number.</small>
                    </div>
                </div>
                <div class="field col-12 md:col-4">
                    <label class="font-medium text-900">On-Campus Other Expenses</label>
                    <input pInputText type="text" class="w-full" placeholder="$ Other expenses"
                        formControlName="onCampusOtherExpenses" />
                    <div
                        *ngIf="form.get('onCampusOtherExpenses')?.touched && form.get('onCampusOtherExpenses')?.invalid">
                        <small *ngIf="form.get('onCampusOtherExpenses')?.hasError('pattern')"
                            class="p-error block mt-1">Must be a number.</small>
                    </div>
                </div>
                <div class="field col-12 md:col-4">
                    <label class="font-medium text-900">Off-Campus Room & Board</label>
                    <input pInputText type="text" class="w-full" placeholder="$ Off-campus housing"
                        formControlName="offCampusRoomBoard" />
                    <div *ngIf="form.get('offCampusRoomBoard')?.touched && form.get('offCampusRoomBoard')?.invalid">
                        <small *ngIf="form.get('offCampusRoomBoard')?.hasError('pattern')"
                            class="p-error block mt-1">Must be a number.</small>
                    </div>
                </div>
                <div class="field col-12 md:col-4">
                    <label class="font-medium text-900">Off-Campus Other Expenses</label>
                    <input pInputText type="text" class="w-full" placeholder="$ Other expenses"
                        formControlName="offCampusOtherExpenses" />
                    <div
                        *ngIf="form.get('offCampusOtherExpenses')?.touched && form.get('offCampusOtherExpenses')?.invalid">
                        <small *ngIf="form.get('offCampusOtherExpenses')?.hasError('pattern')"
                            class="p-error block mt-1">Must be a number.</small>
                    </div>
                </div>
                <div class="field col-12 md:col-4">
                    <label class="font-medium text-900">Housing Capacity</label>
                    <input pInputText type="text" class="w-full" placeholder="Capacity"
                        formControlName="housingCapacity" />
                    <div *ngIf="form.get('housingCapacity')?.touched && form.get('housingCapacity')?.invalid">
                        <small *ngIf="form.get('housingCapacity')?.hasError('pattern')" class="p-error block mt-1">Must
                            be a number.</small>
                    </div>
                </div>
                <div class="field col-12 md:col-4">
                    <label class="font-medium text-900">Combined Food & Housing Charge</label>
                    <input pInputText type="text" class="w-full" placeholder="$ Combined cost"
                        formControlName="combinedFoodHousingCharge" />
                    <div
                        *ngIf="form.get('combinedFoodHousingCharge')?.touched && form.get('combinedFoodHousingCharge')?.invalid">
                        <small *ngIf="form.get('combinedFoodHousingCharge')?.hasError('pattern')"
                            class="p-error block mt-1">Must be a number.</small>
                    </div>
                </div>
                <div class="field col-12 md:col-4">
                    <label class="font-medium text-900">Median Family Income</label>
                    <input pInputText type="text" class="w-full" placeholder="$ Median income"
                        formControlName="medianFamilyIncome" />
                    <div *ngIf="form.get('medianFamilyIncome')?.touched && form.get('medianFamilyIncome')?.invalid">
                        <small *ngIf="form.get('medianFamilyIncome')?.hasError('pattern')"
                            class="p-error block mt-1">Must be a number.</small>
                    </div>
                </div>
                <div class="field col-12 md:col-4">
                    <label class="font-medium text-900">Average Grant Amount</label>
                    <input pInputText type="text" class="w-full" placeholder="$ Average grant"
                        formControlName="avgGrantAmount" />
                    <div *ngIf="form.get('avgGrantAmount')?.touched && form.get('avgGrantAmount')?.invalid">
                        <small *ngIf="form.get('avgGrantAmount')?.hasError('pattern')" class="p-error block mt-1">Must
                            be a number.</small>
                    </div>
                </div>
                <div class="field col-12 md:col-4">
                    <label class="font-medium text-900">% Students Awarded Grant</label>
                    <input pInputText type="text" class="w-full" placeholder="e.g., 60%"
                        formControlName="percentStudentsAwardedGrant" />
                    <div
                        *ngIf="form.get('percentStudentsAwardedGrant')?.touched && form.get('percentStudentsAwardedGrant')?.invalid">
                        <small *ngIf="form.get('percentStudentsAwardedGrant')?.hasError('pattern')"
                            class="p-error block mt-1">Must be a number.</small>
                    </div>
                </div>
                <div class="field col-12 md:col-4">
                    <label class="font-medium text-900">Find Scholarships Link</label>
                    <input pInputText type="text" class="w-full" placeholder="https://..."
                        formControlName="findScholarshipsLink" />
                    <div *ngIf="form.get('findScholarshipsLink')?.touched && form.get('findScholarshipsLink')?.invalid">
                        <small *ngIf="form.get('findScholarshipsLink')?.hasError('pattern')" class="p-error block mt-1">Must
                            contain alphanumeric characters or numbers.</small>
                    </div>
                </div>
            </div>
        </p-accordionTab>

        <p-accordionTab header="Enrollment Statistics">
            <div class="formgrid grid">
                <div class="field col-12 md:col-4">
                    <label class="font-medium text-900">Full-Time Enrollment</label>
                    <input pInputText type="text" class="w-full" placeholder="Full-time students"
                        formControlName="fullTimeEnrollment" />
                    <div *ngIf="form.get('fullTimeEnrollment')?.touched && form.get('fullTimeEnrollment')?.invalid">
                        <small *ngIf="form.get('fullTimeEnrollment')?.hasError('pattern')"
                            class="p-error block mt-1">Must be a number.</small>
                    </div>
                </div>
                <div class="field col-12 md:col-4">
                    <label class="font-medium text-900">Part-Time Enrollment</label>
                    <input pInputText type="text" class="w-full" placeholder="Part-time students"
                        formControlName="partTimeEnrollment" />
                    <div *ngIf="form.get('partTimeEnrollment')?.touched && form.get('partTimeEnrollment')?.invalid">
                        <small *ngIf="form.get('partTimeEnrollment')?.hasError('pattern')"
                            class="p-error block mt-1">Must be a number.</small>
                    </div>
                </div>
                <div class="field col-12 md:col-4">
                    <label class="font-medium text-900">Total Enrollment</label>
                    <input pInputText type="text" class="w-full" placeholder="Total students"
                        formControlName="totalEnrollment" />
                    <div *ngIf="form.get('totalEnrollment')?.touched && form.get('totalEnrollment')?.invalid">
                        <small *ngIf="form.get('totalEnrollment')?.hasError('pattern')" class="p-error block mt-1">Must
                            be a number.</small>
                    </div>
                </div>
                <div class="field col-12 md:col-4">
                    <label class="font-medium text-900">International Students</label>
                    <input pInputText type="text" class="w-full" placeholder="International count"
                        formControlName="internationalStudents" />
                    <div
                        *ngIf="form.get('internationalStudents')?.touched && form.get('internationalStudents')?.invalid">
                        <small *ngIf="form.get('internationalStudents')?.hasError('pattern')"
                            class="p-error block mt-1">Must be a valid percentage.</small>
                    </div>
                </div>
                <div class="field col-12 md:col-4">
                    <label class="font-medium text-900">Male Percentage</label>
                    <input pInputText type="text" class="w-full" placeholder="0-100" formControlName="malePercentage" />
                    <div *ngIf="form.get('malePercentage')?.touched && form.get('malePercentage')?.invalid">
                        <small *ngIf="form.get('malePercentage')?.hasError('pattern')" class="p-error block mt-1">Must
                            be a valid percentage.</small>
                    </div>
                </div>
                <div class="field col-12 md:col-4">
                    <label class="font-medium text-900">Female Percentage</label>
                    <input pInputText type="text" class="w-full" placeholder="0-100"
                        formControlName="femalePercentage" />
                    <div *ngIf="form.get('femalePercentage')?.touched && form.get('femalePercentage')?.invalid">
                        <small *ngIf="form.get('femalePercentage')?.hasError('pattern')" class="p-error block mt-1">Must
                            be a valid percentage.</small>
                    </div>
                </div>
                <div class="field col-12 md:col-4">
                    <label class="font-medium text-900">Full-Time Undergraduate Male Enrollment</label>
                    <input pInputText type="text" class="w-full" placeholder="Male count"
                        formControlName="fullTimeUndergraduateMaleEnrollment" />
                    <div
                        *ngIf="form.get('fullTimeUndergraduateMaleEnrollment')?.touched && form.get('fullTimeUndergraduateMaleEnrollment')?.invalid">
                        <small *ngIf="form.get('fullTimeUndergraduateMaleEnrollment')?.hasError('pattern')"
                            class="p-error block mt-1">Must be a number.</small>
                    </div>
                </div>
                <div class="field col-12 md:col-4">
                    <label class="font-medium text-900">Full-Time Undergraduate Female Enrollment</label>
                    <input pInputText type="text" class="w-full" placeholder="Female count"
                        formControlName="fullTimeUndergraduateFemaleEnrollment" />
                    <div
                        *ngIf="form.get('fullTimeUndergraduateFemaleEnrollment')?.touched && form.get('fullTimeUndergraduateFemaleEnrollment')?.invalid">
                        <small *ngIf="form.get('fullTimeUndergraduateFemaleEnrollment')?.hasError('pattern')"
                            class="p-error block mt-1">Must be a number.</small>
                    </div>
                </div>
                <div class="field col-12 md:col-4">
                    <label class="font-medium text-900">Full-Time Undergraduate Indian Students</label>
                    <input pInputText type="text" class="w-full" placeholder="Indian count"
                        formControlName="fullTimeUnderGraduateIndianStudents" />
                    <div
                        *ngIf="form.get('fullTimeUnderGraduateIndianStudents')?.touched && form.get('fullTimeUnderGraduateIndianStudents')?.invalid">
                        <small *ngIf="form.get('fullTimeUnderGraduateIndianStudents')?.hasError('pattern')"
                            class="p-error block mt-1">Must be a number.</small>
                    </div>
                </div>
            </div>
        </p-accordionTab>

        <p-accordionTab header="Demographics">
            <div class="formgrid grid">
                <div class="field col-12 md:col-3">
                    <label class="font-medium text-900">White</label>
                    <input pInputText type="text" class="w-full" placeholder="%" formControlName="whitePercentage" />
                    <small *ngIf="form.get('whitePercentage')?.hasError('pattern')" class="p-error block mt-1">
                        Must be a valid percentage.
                    </small>
                </div>
                <div class="field col-12 md:col-3">
                    <label class="font-medium text-900">Black/African American</label>
                    <input pInputText type="text" class="w-full" placeholder="%" formControlName="blackPercentage" />
                    <small *ngIf="form.get('blackPercentage')?.hasError('pattern')" class="p-error block mt-1">
                        Must be a valid percentage.
                    </small>
                </div>
                <div class="field col-12 md:col-3">
                    <label class="font-medium text-900">Hispanic/Latino</label>
                    <input pInputText type="text" class="w-full" placeholder="%" formControlName="hispanicPercentage" />
                    <small *ngIf="form.get('hispanicPercentage')?.hasError('pattern')" class="p-error block mt-1">
                        Must be a valid percentage.
                    </small>
                </div>
                <div class="field col-12 md:col-3">
                    <label class="font-medium text-900">Asian</label>
                    <input pInputText type="text" class="w-full" placeholder="%" formControlName="asianPercentage" />
                    <small *ngIf="form.get('asianPercentage')?.hasError('pattern')" class="p-error block mt-1">
                        Must be a valid percentage.
                    </small>
                </div>
                <div class="field col-12 md:col-3">
                    <label class="font-medium text-900">American Indian/Alaska Native</label>
                    <input pInputText type="text" class="w-full" placeholder="%"
                        formControlName="americanIndianPercentage" />
                    <small *ngIf="form.get('americanIndianPercentage')?.hasError('pattern')" class="p-error block mt-1">
                        Must be a valid percentage.
                    </small>
                </div>
                <div class="field col-12 md:col-3">
                    <label class="font-medium text-900">Native Hawaiian/Pacific Islander</label>
                    <input pInputText type="text" class="w-full" placeholder="%"
                        formControlName="nativeHawaiianPercentage" />
                    <small *ngIf="form.get('nativeHawaiianPercentage')?.hasError('pattern')" class="p-error block mt-1">
                        Must be a valid percentage.
                    </small>
                </div>
                <div class="field col-12 md:col-3">
                    <label class="font-medium text-900">Two or More Races</label>
                    <input pInputText type="text" class="w-full" placeholder="%"
                        formControlName="twoOrMoreRacesPercentage" />
                    <small *ngIf="form.get('twoOrMoreRacesPercentage')?.hasError('pattern')" class="p-error block mt-1">
                        Must be a valid percentage.
                    </small>
                </div>
                <div class="field col-12 md:col-3">
                    <label class="font-medium text-900">Race/Ethnicity Unknown</label>
                    <input pInputText type="text" class="w-full" placeholder="%"
                        formControlName="raceUnknownPercentage" />
                    <small *ngIf="form.get('raceUnknownPercentage')?.hasError('pattern')" class="p-error block mt-1">
                        Must be a valid percentage.
                    </small>
                </div>
            </div>
        </p-accordionTab>

        <p-accordionTab header="Academic Information">
            <div class="formgrid grid">
                <div class="field col-12 md:col-4">
                    <label class="font-medium text-900">Student-Faculty Ratio</label>
                    <input pInputText type="text" class="w-full" placeholder="e.g., 15:1"
                        formControlName="studentFacultyRatio" />
                    <div *ngIf="form.get('studentFacultyRatio')?.touched && form.get('studentFacultyRatio')?.invalid">
                        <small *ngIf="form.get('studentFacultyRatio')?.hasError('pattern')"
                            class="p-error block mt-1">Must be a valid ratio (e.g., 15:1).</small>
                    </div>
                </div>
                <div class="field col-12 md:col-4">
                    <label class="font-medium text-900">Number of Courses Offered</label>
                    <input pInputText type="text" class="w-full" placeholder="Total courses"
                        formControlName="numCoursesOffered" />
                    <div *ngIf="form.get('numCoursesOffered')?.touched && form.get('numCoursesOffered')?.invalid">
                        <small *ngIf="form.get('numCoursesOffered')?.hasError('pattern')"
                            class="p-error block mt-1">Must be a number.</small>
                    </div>
                </div>
                <div class="field col-12 md:col-4">
                    <label class="font-medium text-900">Total Departments</label>
                    <input pInputText type="text" class="w-full" placeholder="Number of departments"
                        formControlName="totalDepartments" />
                    <div *ngIf="form.get('totalDepartments')?.touched && form.get('totalDepartments')?.invalid">
                        <small *ngIf="form.get('totalDepartments')?.hasError('pattern')" class="p-error block mt-1">Must
                            be a number.</small>
                    </div>
                </div>
                <div class="field col-12 md:col-4">
                    <label class="font-medium text-900">Faculty Count</label>
                    <input pInputText type="text" class="w-full" placeholder="Number of faculty"
                        formControlName="faculty" />
                    <div *ngIf="form.get('faculty')?.touched && form.get('faculty')?.invalid">
                        <small *ngIf="form.get('faculty')?.hasError('pattern')" class="p-error block mt-1">Must be a
                            number.</small>
                    </div>
                </div>
                <div class="field col-12 md:col-4">
                    <label class="font-medium text-900">Full-Time US Non-Resident Faculty Share</label>
                    <input pInputText type="text" class="w-full" placeholder="%"
                        formControlName="fullTimeUSNonResidentFacultyShare" />
                    <small *ngIf="form.get('fullTimeUSNonResidentFacultyShare')?.hasError('pattern')"
                        class="p-error block mt-1">
                        Must be a valid percentage.
                    </small>
                </div>
                <div class="field col-12 md:col-4">
                    <label class="font-medium text-900">Full-Time Faculty Proportion</label>
                    <input pInputText type="text" class="w-full" placeholder="%"
                        formControlName="fullTimeFacultyProportion" />
                    <small *ngIf="form.get('fullTimeFacultyProportion')?.hasError('pattern')"
                        class="p-error block mt-1">
                        Must be a valid percentage.
                    </small>
                </div>
            </div>
        </p-accordionTab>

        <p-accordionTab header="Outcomes & Success Metrics">
            <div class="formgrid grid">
                <div class="field col-12 md:col-4">
                    <label class="font-medium text-900">Acceptance Rate</label>
                    <input pInputText type="text" class="w-full" placeholder="e.g., 15%"
                        formControlName="acceptanceRate" />
                    <div *ngIf="form.get('acceptanceRate')?.touched && form.get('acceptanceRate')?.invalid">
                        <small *ngIf="form.get('acceptanceRate')?.hasError('pattern')" class="p-error block mt-1">Must
                            be a valid percentage.</small>
                    </div>
                </div>
                <div class="field col-12 md:col-4">
                    <label class="font-medium text-900">Graduation Rate</label>
                    <input pInputText type="text" class="w-full" placeholder="0-100" formControlName="graduationRate" />
                    <div *ngIf="form.get('graduationRate')?.touched && form.get('graduationRate')?.invalid">
                        <small *ngIf="form.get('graduationRate')?.hasError('pattern')" class="p-error block mt-1">Must
                            be a valid percentage.</small>
                    </div>
                </div>
                <div class="field col-12 md:col-4">
                    <label class="font-medium text-900">Median Earnings Post 1 Year</label>
                    <input pInputText type="text" class="w-full" placeholder="e.g., $50,000"
                        formControlName="medianEarnings1Year" />
                    <div *ngIf="form.get('medianEarnings1Year')?.touched && form.get('medianEarnings1Year')?.invalid">
                        <small *ngIf="form.get('medianEarnings1Year')?.hasError('pattern')"
                            class="p-error block mt-1">Must be a number.</small>
                    </div>
                </div>
                <div class="field col-12 md:col-4">
                    <label class="font-medium text-900">Median Earnings Post 5 Years</label>
                    <input pInputText type="text" class="w-full" placeholder="e.g., $90,000"
                        formControlName="medianEarnings5Years" />
                    <div *ngIf="form.get('medianEarnings5Years')?.touched && form.get('medianEarnings5Years')?.invalid">
                        <small *ngIf="form.get('medianEarnings5Years')?.hasError('pattern')"
                            class="p-error block mt-1">Must be a number.</small>
                    </div>
                </div>
                <div class="field col-12 md:col-4">
                    <label class="font-medium text-900">% Earning Above High School (11 Years)</label>
                    <input pInputText type="text" class="w-full" placeholder="%"
                        formControlName="percentEarningAboveHighSchool11Years" />
                    <div
                        *ngIf="form.get('percentEarningAboveHighSchool11Years')?.touched && form.get('percentEarningAboveHighSchool11Years')?.invalid">
                        <small *ngIf="form.get('percentEarningAboveHighSchool11Years')?.hasError('pattern')"
                            class="p-error block mt-1">Must be a valid percentage.</small>
                    </div>
                </div>
                <div class="field col-12 md:col-4">
                    <label class="font-medium text-900">International Students Graduation Rate</label>
                    <input pInputText type="text" class="w-full" placeholder="%"
                        formControlName="internationalStudentsGraduationRate" />
                    <div
                        *ngIf="form.get('internationalStudentsGraduationRate')?.touched && form.get('internationalStudentsGraduationRate')?.invalid">
                        <small *ngIf="form.get('internationalStudentsGraduationRate')?.hasError('pattern')"
                            class="p-error block mt-1">Must be a valid percentage.</small>
                    </div>
                </div>
                <div class="field col-12 md:col-4">
                    <label class="font-medium text-900">Food And Other Expenses</label>
                    <input pInputText type="text" class="w-full" placeholder="$ Other"
                        formControlName="foodAndOtherExpenses" />
                </div>
            </div>
        </p-accordionTab>

        <p-accordionTab header="Additional Information">
            <div class="formgrid grid">
                <div class="field col-12 md:col-3">
                    <label class="font-medium text-900">UK Institute</label>
                    <input pInputText type="text" class="w-full" placeholder="e.g., 10%" formControlName="uk" />
                    <div *ngIf="form.get('uk')?.touched && form.get('uk')?.invalid">
                        <small *ngIf="form.get('uk')?.hasError('pattern')" class="p-error block mt-1">
                            Must be a valid percentage.
                        </small>
                    </div>
                </div>
                <div class="field col-12 md:col-3">
                    <label class="font-medium text-900">EU Institute</label>
                    <input pInputText type="text" class="w-full" placeholder="e.g., 10%" formControlName="eu" />
                    <div *ngIf="form.get('eu')?.touched && form.get('eu')?.invalid">
                        <small *ngIf="form.get('eu')?.hasError('pattern')" class="p-error block mt-1">
                            Must be a valid percentage.
                        </small>
                    </div>
                </div>
                <div class="field col-12 md:col-3">
                    <label class="font-medium text-900">Post Graduate Offerings</label>
                    <input pInputText type="text" class="w-full" placeholder="e.g., 10%"
                        formControlName="postGraduate" />
                    <div *ngIf="form.get('postGraduate')?.touched && form.get('postGraduate')?.invalid">
                        <small *ngIf="form.get('postGraduate')?.hasError('pattern')" class="p-error block mt-1">
                            Must be a valid percentage.
                        </small>
                    </div>
                </div>
                <div class="field col-12 md:col-3">
                    <label class="font-medium text-900">Under Graduate Offerings</label>
                    <input pInputText type="text" class="w-full" placeholder="e.g., 10%"
                        formControlName="underGraduate" />
                    <div *ngIf="form.get('underGraduate')?.touched && form.get('underGraduate')?.invalid">
                        <small *ngIf="form.get('underGraduate')?.hasError('pattern')" class="p-error block mt-1">
                            Must be a valid percentage.
                        </small>
                    </div>
                </div>
            </div>
            <div class="field mt-4">
                <label class="font-medium text-900">Popular Employers</label>
                <textarea pInputTextarea rows="2" class="w-full" placeholder="List top employers of graduates"
                    formControlName="popularEmployers"></textarea>
                <div *ngIf="form.get('popularEmployers')?.touched && form.get('popularEmployers')?.invalid">
                    <small *ngIf="form.get('popularEmployers')?.hasError('pattern')" class="p-error block mt-1">
                        Must be alphabetic.
                    </small>
                </div>
            </div>
            <div class="field">
                <label class="font-medium text-900">Additional Notes</label>
                <textarea pInputTextarea rows="2" class="w-full" placeholder="Any additional information"
                    formControlName="additionalNotes"></textarea>
            </div>
        </p-accordionTab>


    </p-accordion>

</div>